import React from "react";
import {Checkbox, Radio, Select} from "antd";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import LocaleText from "../../../../settings/dictionary/LocaleText";

interface IProps {
    options: IFieldOptions;
    value?: any;
    onChange?: (value: any) => void;
}

interface IState {
    // Keeps track of the value if it's managed locally, or drops back to props
    value?: any;
}

class FormFieldSelect extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        // Sync internal state if parent value updates dynamically
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    handleChange = (newValue: any) => {
        this.setState({ value: newValue });
        if (this.props.onChange) {
            this.props.onChange(newValue);
        }
    };

    render() {
        const { options } = this.props;
        const { value } = this.state;

        const componentProps = {
            style: options.style,
            placeholder: options.placeholder,
            allowClear: options.showClear,
            disabled: options.disabled,
            value: value
        };

        let selectMode = options.selectMode;

        if (!selectMode) {
            selectMode = 'auto';
        }
        if (selectMode === "auto" && options.selectOptions) {
            selectMode = options.selectOptions.length < 6 ? 'radio' : 'select';
        }

        if (selectMode === 'radio') {
            return options.multiple ? (
                <Checkbox.Group
                    {...componentProps}
                    onChange={(checkedValues) => this.handleChange(checkedValues)}
                >
                    {options.selectOptions?.map((item, i) => (
                        <Checkbox
                            className={'d-inline-flex align-items-center'}
                            key={i}
                            value={item}
                        >
                            <LocaleText code={item} />
                        </Checkbox>
                    ))}
                </Checkbox.Group>
            ) : (
                <Radio.Group
                    {...componentProps}
                    onChange={(e) => this.handleChange(e.target.value)}
                >
                    {options.selectOptions?.map((val, i) => (
                        <Radio
                            className={'d-inline-flex align-items-center'}
                            key={i}
                            value={val}
                        >
                            <LocaleText code={val} />
                        </Radio>
                    ))}
                </Radio.Group>
            );
        }

        return (
            <Select
                {...componentProps}
                mode={options.multiple ? 'multiple' : undefined}
                onChange={(val) => this.handleChange(val)}
            >
                {options.selectOptions?.map((option, i) => (
                    <Select.Option key={i} value={option}>
                        <LocaleText code={option} />
                    </Select.Option>
                ))}
            </Select>
        );
    }
}

export default FormFieldSelect;